import { render, staticRenderFns } from "./playerList.vue?vue&type=template&id=343942cb"
import script from "./playerList.vue?vue&type=script&lang=js"
export * from "./playerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343942cb')) {
      api.createRecord('343942cb', component.options)
    } else {
      api.reload('343942cb', component.options)
    }
    module.hot.accept("./playerList.vue?vue&type=template&id=343942cb", function () {
      api.rerender('343942cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/player/playerList.vue"
export default component.exports